document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.nked-reviews').forEach((section) => {
    const track = section.querySelector('[data-track]');
    const prevBtn = section.querySelector('[data-prev]');
    const nextBtn = section.querySelector('[data-next]');
    const cards = track ? Array.from(track.children) : [];
    if (!track || !cards.length) return;

    const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

    function metrics() {
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || '0');
      const cardW = cards[0].getBoundingClientRect().width;
      return { gap, cardW };
    }

    function step() {
      const { gap, cardW } = metrics();
      return cardW + gap;
    }

    /* Desktop rest position: show an equal sliver of a card at BOTH the left
       and right edges of the track, with whole cards between. Mobile stays at 0
       (free scroll from the first card). */
    function restOffset() {
      if (!isDesktop()) return 0;
      const { gap, cardW } = metrics();
      const visible = track.clientWidth;
      const pitch = cardW + gap;
      let n = Math.max(1, Math.floor((visible - 2 * gap) / pitch));
      let peek = (visible - (n * cardW + (n - 1) * gap) - 2 * gap) / 2;
      if (peek < 24 && n > 1) {
        n -= 1;
        peek = (visible - (n * cardW + (n - 1) * gap) - 2 * gap) / 2;
      }
      peek = Math.max(0, Math.min(peek, cardW - 1));
      return Math.max(0, Math.round(cardW - peek));
    }

    function updateButtons() {
      const rest = restOffset();
      const maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= rest + 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function applyRest() {
      track.scrollLeft = restOffset();
      updateButtons();
    }

    prevBtn.addEventListener('click', () => {
      const target = Math.max(restOffset(), track.scrollLeft - step());
      track.scrollTo({ left: target, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateButtons);
    });

    window.addEventListener('resize', applyRest);
    window.addEventListener('load', applyRest);
    applyRest();
  });
});
